/**
 *
 * Asynchronously loads the component for Mse006
 * Author: TruongTx
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
